import { Component } from '@angular/core';

@Component({
  selector: 'app-authentication-failed',
  templateUrl: './authentication-failed.component.html',
  styleUrls: ['./authentication-failed.component.scss']
})
export class AUTHENTICATIONFAILEDComponent {

}
